module.exports = __webpack_public_path__ + "static/img/pitaya.cfe15bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/pitaya.jpg
// module id = 0yXf
// module chunks = 1